import { render, staticRenderFns } from "./NoLevelsView.vue?vue&type=template&id=4b1cf114&functional=true&"
import script from "./NoLevelsView.vue?vue&type=script&lang=ts&"
export * from "./NoLevelsView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports